
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.615 10.92a6.534 6.534 0 01-9.676 5.73c-.712-.391-1.629-.382-2.204.193l-2.653 2.652a.408.408 0 11-.577-.577l2.652-2.653c.575-.575.584-1.492.193-2.204a6.534 6.534 0 1112.265-3.141zm-.817 0a5.717 5.717 0 11-11.435 0 5.717 5.717 0 0111.435 0z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.162 10.92a6.92 6.92 0 113.592 6.068c-.608-.334-1.326-.294-1.747.127l-2.653 2.653a.793.793 0 11-1.122-1.122l2.653-2.653c.421-.421.462-1.139.127-1.747a6.89 6.89 0 01-.85-3.327zm6.919-6.15a6.15 6.15 0 00-5.394 9.105c.45.818.472 1.933-.257 2.662L4.777 19.19a.023.023 0 10.033.033l2.653-2.653c.729-.729 1.844-.706 2.662-.257A6.15 6.15 0 1013.08 4.77zm-6.103 6.15a6.102 6.102 0 1112.205 0 6.102 6.102 0 01-12.205 0zm6.103-5.333a5.332 5.332 0 100 10.665 5.332 5.332 0 000-10.665z","fill":"currentColor"}})])
          )
        }
      }
    